import { render } from "./Kirchensteuerverfahren.vue?vue&type=template&id=aca0cde2"
import script from "./Kirchensteuerverfahren.vue?vue&type=script&lang=js"
export * from "./Kirchensteuerverfahren.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/Vakifbank-Vue-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__